
















import {defineComponent, onMounted, ref, Ref} from "@vue/composition-api";

export default defineComponent({
    name: "MoleculeAccordionItem",
    props: {
        expand: {type: Boolean, default: false},
        isDisabled: {type: Boolean, default: false}
    },
    setup: (props) => {
        const isOpen: Ref<boolean> = ref(false);

        function toggleAccordion() {
            isOpen.value = !isOpen.value;
        }

        onMounted(() => {
            isOpen.value = props.expand;
        });

        return {
            toggleAccordion,
            isOpen
        }
    }
})
